"use client";
import getWebviewUrl from "@/utils/webview/getWebviewUrl";
import { useContext } from "react";
import { WebviewContext } from "./WebviewContext";

const useWebview = () => {
  const isWebview = useContext(WebviewContext);

  if (isWebview === undefined) {
    throw new Error("useWebview must be used within a WebviewProvider");
  }

  const getUrl = (url?: string): string | undefined => {
    if (!url) return url;
    return isWebview ? getWebviewUrl(url) : url;
  };

  return { isWebview, getUrl };
};

export default useWebview;
